import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { MagicMarkdown } from '../common/MagicMarkdown';
import { AiDisclaimer } from '../common/AiDisclaimer';

export const SummaryPanel = ({ title, body }) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-4">
      {title && (
        <Typography component="h3" variant="body-lg" weight="bold" height="tight" color="primary">
          {title}
        </Typography>
      )}
      {/* The summary shares the banner's height with the pills on desktop only, so the clamp that
          keeps an over-long answer from stretching the card is scoped to `lg`. */}
      <div className="lg:sui-line-clamp-6">
        <MagicMarkdown>{body}</MagicMarkdown>
      </div>
      <AiDisclaimer />
    </div>
  );
};

SummaryPanel.displayName = 'SummaryPanel';

SummaryPanel.propTypes = {
  /** Plain-text summary title, shown as the panel heading (its own API field, not markdown). */
  title: PropTypes.string,
  /** The AI answer as a markdown string. */
  body: PropTypes.string,
};
